export class ProfileModel {
    profileDto: ProfileDto = new ProfileDto();
    addressDto: addressDto[] = [];
  }
  export class ProfileDto {
    titleId: number = null;
    title?: string = '';
    firstName: string = '';
    middleName?: string = '';
    lastName: string = '';
    dateOfBirth: string = '';
    fatherName: string = '';
    genderCode: number = null;
    maritalStatusCode: number = null;
    profileId: number = 0;
  }
  export class addressDto {
    id?: number = null;
    address: any = '';
    addressTypeCode: number = null;
    countryId: number = null;
    domicileId: number = null;
    postalCodeId: number = null;
    cityId: number = null;
  }